import { articlesEn } from "@/mocks/articles.en";
import { articlesPl } from "@/mocks/articles.pl";
import { articlesEs } from "@/mocks/articles.es";
import { articlesFr } from "@/mocks/articles.fr";

export interface ArticleSection {
  heading?: string;
  paragraphs?: string[];
  list?: string[];
  table?: { headers: string[]; rows: string[][] };
}

export interface ArticleFaq {
  q: string;
  a: string;
}

export interface Article {
  slug: string;
  seoTitle: string;
  metaDescription: string;
  h1: string;
  intro: string;
  updatedDate: string;
  readingTime: string;
  sections: ArticleSection[];
  faq: ArticleFaq[];
  relatedCategories: string[];
}

export const supportedLangs = ["en", "pl", "es", "fr"] as const;

export type Lang = (typeof supportedLangs)[number];

export const defaultLang: Lang = "en";

export const articlesByLang: Record<Lang, Article[]> = {
  en: articlesEn,
  pl: articlesPl,
  es: articlesEs,
  fr: articlesFr,
};